import { ArrowBackRounded } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { mboPaymentDashboardServices } from "./data";
import DiscountMaster from "./DiscountMaster/DiscountMaster";
import DiscountMasterList from "./DiscountMaster/DiscountMasterList";
import DiscountSummaryPage from "./DiscountMaster/DiscountSummary";
import NODPage from "./DiscountMaster/NOD/Nod";
import ApprovalMAster from "./DiscountMaster/ApprovalMaster/ApprovalMaster";
import DiscountStoreMaster from "./DiscountMaster/DiscountStoreMaster/DiscountStoreMaster";

function MboPaymentWorking() {
	const navigate = useNavigate();
	const [currentPath, service] = useOutletContext();

	const tabComponents = {
		[mboPaymentDashboardServices.masters.types.discount_master.key]: {
			...mboPaymentDashboardServices.masters.types.discount_master.key,
			component: <DiscountMasterList />,
		},
		[mboPaymentDashboardServices.masters.types.create_discount.key]: {
			...mboPaymentDashboardServices.masters.types.create_discount.key,
			component: <DiscountMaster />,
		},
		[mboPaymentDashboardServices.masters.types.discount_summary.key]: {
			...mboPaymentDashboardServices.masters.types.discount_summary.key,
			component: <DiscountSummaryPage />,
		},
		[mboPaymentDashboardServices.masters.types.nod.key]: {
			...mboPaymentDashboardServices.masters.types.nod.key,
			component: <NODPage />,
		},
		[mboPaymentDashboardServices.master.types.store_master.key]: {
			...mboPaymentDashboardServices.master.types.store_master.key,
			component: <DiscountStoreMaster />,
		},
		[mboPaymentDashboardServices.master.types.approval_master.key]: {
			...mboPaymentDashboardServices.master.types.approval_master.key,
			component: <ApprovalMAster />,
		},
	};

	return (
		<Box width={"100%"} p={1}>
			<Box display="flex" alignItems="center" columnGap={1} mt={2}>
				<IconButton onClick={() => navigate(-1)}>
					<ArrowBackRounded />
				</IconButton>
				<Typography variant="h5">{service?.name}</Typography>
			</Box>
			{tabComponents?.[currentPath]?.component}
		</Box>
	);
}

export default MboPaymentWorking;
